// @ts-nocheck
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Switch as MuiSwitch, SwitchProps as MuiSwitchProps, TypographyProps } from '@mui/material';
import { AnyObject, OmitControl } from '@trackman/web-shared-components/components/types';
import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { brand, lightgrey } from 'styles/Colors';
import FormControlLabel, { FormControlLabelProps } from './FormControlLabel';

export const MuiBoxSizingWildcard = (props: AnyObject) =>
  css`
    &,
    & *,
    & *::before,
    & *::after {
      box-sizing: ${props.theme.boxSizing};
    }
  `;

export type SwitchProps = OmitControl<
  FormControlLabelProps & {
    /**
     * @since 3.0.0 - Change type to {@link ReactNode}
     * @description Helper text
     */
    hint?: ReactNode;
    /**
     * @since 3.0.0 - New prop
     * @description Disable Hint Typography wrapper
     */
    disableHintTypography?: boolean;
    /**
     * @description Same as {@link FormControlLabelProps['componentsProps']} with hintTypography property
     */
    componentsProps?: FormControlLabelProps['componentsProps'] & {
      hintTypography?: TypographyProps;
      switchBase?: MuiSwitchProps;
    };
    color?: any;
    leftContent?: React.ReactNode;
    rightContent?: React.ReactNode;
  } & Pick<MuiSwitchProps, 'required'>
>;

const SwitchBase = styled(MuiSwitch)`
  width: 40px;
  height: 24px;
  padding: 0;

  ${MuiBoxSizingWildcard}

  & .MuiSwitch-switchBase {
    padding: 2px;

    :hover {
      background-color: transparent;
    }

    &.Mui-checked {
      transform: translateX(16px);

      + .MuiSwitch-track {
        ::before {
          content: '';
          position: absolute;
          width: calc(100% - 4px);
          height: calc(100% - 4px);
          border: 2px solid rgba(0, 0, 0, 0.1);
          border-radius: 12px;
          box-sizing: content-box;
        }
      }
    }

    &,
    &.Mui-checked {
      color: white;

      + .MuiSwitch-track {
        opacity: 1;
      }
    }

    &.Mui-disabled + .MuiSwitch-track {
      opacity: 1;
    }
  }

  &&& .MuiSwitch-track {
    border-radius: 12px;
    background-color: ${lightgrey};
  }

  &&& .Mui-checked + .MuiSwitch-track {
    background-color: ${brand};
  }
`;

const SwitchWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

const Switch: React.FC<SwitchProps> = React.forwardRef<HTMLLabelElement, SwitchProps>((props, ref) => {
  const {
    label,
    hint: hintProp = null,
    disableHintTypography,
    componentsProps,
    color,
    required,
    checked,
    onClick,
    leftContent,
    rightContent,
    ...rest
  } = props;
  const { readOnly } = props;

  return (
    <FormControlLabel
      ref={ref}
      label={<>{label}</>}
      control={
        <SwitchWrapper>
          {leftContent}
          <SwitchBase
            checked={checked}
            readOnly={readOnly}
            color={color}
            required={required}
            {...componentsProps?.switchBase}
            onClick={() => {}}
          />
          {rightContent}
        </SwitchWrapper>
      }
      {...rest}
      onClick={onClick}
      componentsProps={{ typography: componentsProps?.typography }}
    />
  );
});

export default Switch;
